import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';


export const CollectioncategoryTypeMappingListing = ({collectioncategoryTypeMappingData, handleClick}) => {

    const [collectioncategoryTypeMapping, setCollectioncategoryTypeMapping] = useState([]);

    const contentRowNames = ["collectionTypeName","collectionTypeCode", "isActive"]

    useEffect(() => {
        trackPromise(
            setCollectioncategoryTypeMappingData()
            )
    }, [collectioncategoryTypeMappingData]);

    async function setCollectioncategoryTypeMappingData() { 
        destroyDataTable();
        await setCollectioncategoryTypeMapping(collectioncategoryTypeMappingData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? 
                (da[row]  ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                :<td key={index}>{da[row] + " "}</td>
            )
         )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                        <table id="example" className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>CollectionType Name</th>
                                    <th>CollectionType Code</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {collectioncategoryTypeMapping.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            <td onClick={() => handleClick(data)} style={{cursor: "pointer"}}><i class="far fa-edit"></i></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


